/** Host-neutral OData string-literal helpers. Normalization, gates and fault reporting belong to callers. */
export class kODataStringCore {
    /** DOCUMENTED EXCEPTION: strict pure string quoting; retains apostrophes as doubled literal delimiters. */
    public static Quote = (Value: string): string => {
        return Value.split("'").join("''");
    };

    /** DOCUMENTED EXCEPTION: quote before encoding the whole value; this is not a path-segment encoder. */
    public static Encode = (Value: string): string => {
        return encodeURIComponent(kODataStringCore.Quote(Value));
    };
}
